<div class="thank-you-container">
    <h1>Thank You!</h1>
    <p>Your submission has been received successfully.</p>
  </div>
  